@import '~style-sheet-helpers/core.less';

.shipment-details-wrapper {
  align-items: center;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 1045px;
  min-width: 964px;
  height: 100%;
}

.shipment-details-wrapper-background {
  position: fixed;
  inset: 0;
  background: transparent;
}

.shipment-details-arrow-previous,
.shipment-details-arrow-next {
  position: relative;
  align-self: center;
  width: 40px;
  height: 40px;
}

.shipment-details-arrow-previous {
  margin-right: 15px;
}

.shipment-details-arrow-next {
  margin-left: 15px;
}

.shipment-details-modal {
  margin: 0 55px;
  max-height: 100%;
  width: 100%;
}

.shipment-details-modal-body {
  height: 100%;
}
